import { render } from "./NoticiaCardHome.vue?vue&type=template&id=1b614e9c&scoped=true"
import script from "./NoticiaCardHome.vue?vue&type=script&lang=js"
export * from "./NoticiaCardHome.vue?vue&type=script&lang=js"

import "./NoticiaCardHome.vue?vue&type=style&index=0&id=1b614e9c&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b614e9c"]])

export default __exports__